import React, { Component } from "react";
import "./skills.css";
import { SkillsData } from "../../../shared/skillsData.js";

class Skills extends Component {
    constructor(props) {
        super(props);
        this.state = {
            skills : SkillsData
        }
    }
    render(){

        const data = this.state.skills.map((index)=>{
            return(
                <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                    <div className="card pl-4 mb-4" style={{width: "18rem"}}>
                        <div className="card-body">
                            <h4 className="text-center mb-3 pr-4 mr-4">{index.progress}</h4>
                            <div className="stars-outer mr-5 mb-2">
                                <div className="stars-inner" style={{width: makeStar(index.star)}}>

                                </div>
                            </div><br />
                            <div className="tox-progress" data-size="180" data-thickness="10" data-color={index.color} data-background="#ffffff" data-progress={index.progress_bar} data-speed="500">
                                <div className="tox-progress-content pt-4 mt-2 text-center">
                                        {index.course_name}<br/>
                                        <img src={index.image} alt={index.course_name} style={{width: "30%"}} className="mt-2" />
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            );
        })
        return (
            <div className="skills-div text-center">
                <div className="row mt-4">
                    
                        <h1 className="text-center ml-5">Skills</h1>
                    
                </div>
                <div className="container">
                    <div className = "row">
                        {data}
                    </div>
                </div>
            </div>
        );
    }
};

function makeStar(rating)
{
    return(
        rating*15
    )
}

export default Skills